import React from "react";
import PropTypes from "prop-types";
import ChatHeader from "./ChatHeader";
import ChatMessage from "./ChatMessage";
import ChatField from "./ChatField";

const ChatPane = ({
  selectedThread,
  messages,
  onBack,
  showBackButton,
  onSendMessage,
  chatId,
  isBlocked,
  isBlockedBy,
  scrollbarRef,
}) => {
  return (
    <section className={`card pane ${!showBackButton && !selectedThread ? "show-list" : ""}`}>
      <ChatHeader
        selectedThread={selectedThread}
        onBack={onBack}
        showBackButton={showBackButton}
      />

      {!selectedThread ? (
        <div className="empty">
          <div>Select a chat to start messaging</div>
        </div>
      ) : (
        <>
          <div className="pane-body" ref={scrollbarRef}>
            {messages.length === 0 && (
              <div className="empty">
                <div>No messages yet</div>
              </div>
            )}
            {messages.map((message, i) => (
              <ChatMessage key={message._id || i} message={message} />
            ))}
          </div>
          {!isBlocked && !isBlockedBy && chatId && (
            <div className="pane-input-wrapper">
              <ChatField onSendMessage={onSendMessage} ChatId={chatId} />
            </div>
          )}
          {isBlocked && (
            <div style={{ 
              padding: "12px", 
              textAlign: "center", 
              background: "rgba(15,23,42,0.95)", 
              borderTop: "1px solid #1f2937" 
            }}>
              <h4 style={{ color: "#fb7185", margin: 0 }}>
                <i className="fa fa-ban" style={{ marginRight: 8 }} />
                You blocked this user
              </h4>
            </div>
          )}
          {isBlockedBy && (
            <div style={{ 
              padding: "12px", 
              textAlign: "center", 
              background: "rgba(15,23,42,0.95)", 
              borderTop: "1px solid #1f2937" 
            }}>
              <h4 style={{ color: "#fb7185", margin: 0 }}>
                <i className="fa fa-ban" style={{ marginRight: 8 }} />
                This user blocked you
              </h4>
            </div>
          )}
        </>
      )}
    </section>
  );
};

ChatPane.propTypes = {
  selectedThread: PropTypes.object,
  messages: PropTypes.array.isRequired,
  onBack: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool,
  onSendMessage: PropTypes.func.isRequired,
  chatId: PropTypes.string,
  isBlocked: PropTypes.bool,
  isBlockedBy: PropTypes.bool,
  scrollbarRef: PropTypes.object,
};

ChatPane.defaultProps = {
  selectedThread: null,
  showBackButton: false,
  chatId: "",
  isBlocked: false,
  isBlockedBy: false,
  scrollbarRef: null,
};

export default ChatPane;

